import requests from "./httpServiceKey"

const basicMarginServices = {
    getBasicMargin: async () => {
        return requests.get(`cityMargin/basic`)
    },

    getBasicMarginByCity: async (cityId) => {
        return requests.get(`cityMargin/basic/${cityId}`)
    },

    updateBasicMarginByCity: async (cityId, payload) => {
        return requests.put(`cityMargin/basic/update/${cityId}`, payload)
    }
}


const overRideMarginServices = {
    getOverRideMargin: async () => {
        return requests.get(`cityMargin/override`)
    },

    getOverRideMarginByCity: async (cityId) => {
        return requests.get(`cityMargin/override/${cityId}`)
    },

    getOverRideMarginBySingleId: async (id) => {
        return requests.get(`cityMargin/override/single/${id}`)
    },

    toggleMarginStatus: async (id,payload) => {
        return requests.patch(`cityMargin/override/patch/${id}`,payload)
    },

    addOverRideMargin: async (payload) => {
        return requests.post(`cityMargin/override/add`, payload)
    },

    updateOverRideMarginById: async (id, payload) => {
        return requests.put(`cityMargin/override/update/${id}`, payload)
    },
    deleteOverRideMarginById: async (id, payload) => {
        return requests.delete(`cityMargin/override/delete/${id}`, payload)
    },
}

const itineraryBasicMarginServices = {
    getBasicMargin: async () => {
        return requests.get(`fixedItenaryMargin/basic`)
    },

    getBasicMarginByCity: async (cityId) => {
        return requests.get(`fixedItenaryMargin/basic/${cityId}`)
    },

    updateBasicMarginByCity: async (cityId, payload) => {
        return requests.put(`fixedItenaryMargin/basic/update/${cityId}`, payload)
    }
}


const itineraryOverRideMarginServices = {
    getOverRideMargin: async () => {
        return requests.get(`fixedItenaryMargin/override`)
    },

    getOverRideMarginByCity: async (cityId) => {
        return requests.get(`fixedItenaryMargin/override/${cityId}`)
    },

    getOverRideMarginBySingleId: async (id) => {
        return requests.get(`fixedItenaryMargin/override/single/${id}`)
    },

    toggleMarginStatus: async (id,payload) => {
        return requests.patch(`fixedItenaryMargin/override/patch/${id}`,payload)
    },

    addOverRideMargin: async (payload) => {
        return requests.post(`fixedItenaryMargin/override/add`, payload)
    },

    updateOverRideMarginById: async (id, payload) => {
        return requests.put(`fixedItenaryMargin/override/update/${id}`, payload)
    },
    deleteOverRideMarginById: async (id, payload) => {
        return requests.delete(`fixedItenaryMargin/override/delete/${id}`, payload)
    },
}


export {basicMarginServices, overRideMarginServices, itineraryBasicMarginServices, itineraryOverRideMarginServices}